import { lazy } from 'react';

export const ResetPasswordPage = lazy(() => import('./ResetPasswordPage'));
